// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"144":"b70ddb26","335":"45472eb5","407":"45472eb5"}[chunkId] + ".css";
};